<template>
  <section-component
    v-if="hasData"
    :title="title"
    :subtitle="subtitle"
    :isTitleClickable="false"
    :class="getCarouselClass"
    class="carousel-section"
  >
    <app-carousel
      :items="cards"
      :settings="getCarouselSettings"
      :centered="carouselCentered"
      class="carousel-section__carousel"
    >
      <template #default="{ model }">
        <carousel-card v-if="!fullCard" :card="model" :isExpert="checkIfExpert" />
        <product-item v-if="fullCard" :item="model" @click="$emit('itemClicked')" />
      </template>
    </app-carousel>
  </section-component>
</template>
<script>
import navigationMixin from '@/components/common/mixins/navigationMixin'
import screenWidthMixin from '@/components/common/mixins/screenWidthMixin'
import transformEntriesMixin from '@/components/common/mixins/transformEntriesMixin'

import AppCarousel from '@/components/common/AppCarousel.vue'
import CarouselCard from '@/components/common/CarouselCard.vue'
import ProductItem from '@/components/common/ProductItem.vue'

import SectionComponent from '@/components/home/ui/SectionComponent.vue'

export default {
  name: 'CarouselSection',
  components: {
    SectionComponent,
    AppCarousel,
    CarouselCard,
    ProductItem,
  },
  mixins: [navigationMixin, screenWidthMixin, transformEntriesMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    cards: {
      type: Array,
      default: () => [],
    },
    carouselType: {
      type: String,
      default: '',
    },
    fullCard: {
      type: Boolean,
    },
    carouselCentered: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['itemClicked'],
  computed: {
    hasData() {
      return this.cards?.length
    },
    getCarouselClass() {
      switch (this.carouselType) {
        case 'small':
          return 'carousel-section__small'
        case 'large':
          return 'carousel-section__large'
        case 'experts':
          return 'carousel-section__experts'
        default:
          return ''
      }
    },
    checkIfExpert() {
      return this.carouselType === 'experts'
    },
    getCarouselSettings() {
      const navigation = {
        prevEl: `.app-carousel__button--prev-${this.carouselType}-carousel`,
        nextEl: `.app-carousel__button--next-${this.carouselType}-carousel`,
        clickable: true,
      }
      const breakpoints = this.checkIfExpert
        ? {
            768: {
              slidesPerView: 1,
            },
            900: {
              slidesPerView: 2,
            },
            1179: {
              slidesPerView: 3,
            },
          }
        : {
            768: {
              slidesPerView: 2,
            },
            900: {
              slidesPerView: 3,
            },
            1179: {
              slidesPerView: 4,
            },
            1399: {
              slidesPerView: 5,
            },
            1400: {
              slidesPerView: 6,
            },
          }

      return {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        navigation,
        breakpoints,
      }
    },
  },
}
</script>
